import { useAppSelector } from '../redux/hooks';

const useVenueId = () => {
  const venueId = useAppSelector((state) => state.venue.value?.id);

  return venueId;
};

export default useVenueId;
